import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Resource } from '@centers/interfaces/resource';
import { Observable } from 'rxjs';
import BookingEventCalendarPublic from '@bookings/pages/booking-event-calendar-public-page/booking-event-calendar-public-page.vue';
import BookingEventWeeklyCalendarPublic from '@bookings/pages/booking-event-weekly-calendar-public/booking-event-weekly-calendar-public.vue';

@Component({
  name: 'bpc-resource-single',
  components: {
    'bpc-booking-event-calendar-public': BookingEventCalendarPublic,
    'bpc-booking-event-weekly-calendar-public': BookingEventWeeklyCalendarPublic,
  },
})
export default class ResourceSingle extends Vue {
  @Prop(String) readonly alias: string;

  public loading: boolean = false;
  public resourceSubscription = null;
  public resource: Resource = null;

  created() {
    if (this.alias) {
      this.getEntity();
    }
  }

  public getEntity(): void {
    this.loading = true;

    if (this.resourceSubscription) {
      this.resourceSubscription.unsubscribe();
    }

    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('resource', 'raw')}/details/${
      this.alias
    }`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(
      fetchEntityPath,
      {},
      'public',
    );

    this.resourceSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.resource = res.data;
      },
      error => {
        this.loading = false;
        console.log(error);
      },
      () => {
        this.loading = false;
      },
    );
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  @Watch('alias')
  onChangeAlias() {
    this.getEntity();
  }
}
